import { render, staticRenderFns } from "./maboutchild.vue?vue&type=template&id=62100a6c"
import script from "./maboutchild.vue?vue&type=script&lang=js"
export * from "./maboutchild.vue?vue&type=script&lang=js"
import style0 from "./maboutchild.vue?vue&type=style&index=0&id=62100a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports